/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Available_ExtrasInputs */

const en_admin_resource_form_available_extras = /** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available extras`)
};

const de_admin_resource_form_available_extras = /** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Extras`)
};

const es_admin_resource_form_available_extras = /** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras disponibles`)
};

const fr_admin_resource_form_available_extras = /** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extras disponibles`)
};

/** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */
const it_admin_resource_form_available_extras = en_admin_resource_form_available_extras;

/** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */
const pt_br2_admin_resource_form_available_extras = en_admin_resource_form_available_extras;

/** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */
const pl_admin_resource_form_available_extras = en_admin_resource_form_available_extras;

/** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */
const hu_admin_resource_form_available_extras = en_admin_resource_form_available_extras;

/** @type {(inputs: Admin_Resource_Form_Available_ExtrasInputs) => LocalizedString} */
const ro_admin_resource_form_available_extras = en_admin_resource_form_available_extras;

/**
* | output |
* | --- |
* | "Available extras" |
*
* @param {Admin_Resource_Form_Available_ExtrasInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_available_extras = /** @type {((inputs?: Admin_Resource_Form_Available_ExtrasInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Available_ExtrasInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_available_extras(inputs)
	if (locale === "de") return de_admin_resource_form_available_extras(inputs)
	if (locale === "es") return es_admin_resource_form_available_extras(inputs)
	if (locale === "fr") return fr_admin_resource_form_available_extras(inputs)
	if (locale === "it") return it_admin_resource_form_available_extras(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_available_extras(inputs)
	if (locale === "pl") return pl_admin_resource_form_available_extras(inputs)
	if (locale === "hu") return hu_admin_resource_form_available_extras(inputs)
	return ro_admin_resource_form_available_extras(inputs)
});
export { admin_resource_form_available_extras as "admin.resource_form.available_extras" }